var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 124.5 100.3",
    style: {
      enableBackground: "new 0 0 124.5 100.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1896C2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.4,29.4c-2.8,0-5.5,0.6-8,1.7V26C96.4,15,87.4,6,76.3,6C69.2,6,62.6,9.7,59,15.8c-3.2-2.1-7-3.2-10.8-3.2 c-5.2,0-10.2,2-13.9,5.6c-0.7,0.7-0.8,1.9,0,2.6c0.7,0.7,1.9,0.8,2.6,0c3.1-3,7.1-4.6,11.4-4.6c3.2,0,6.3,0.9,9,2.7 c0.8,0.5,1.8,0.7,2.7,0.5c0.9-0.2,1.7-0.8,2.2-1.6c2.9-5,8.4-8.2,14.2-8.2c9,0,16.4,7.4,16.4,16.4v5.3c0,1.2,0.6,2.3,1.6,2.9 c1,0.6,2.3,0.7,3.4,0.2c2.1-1,4.4-1.4,6.7-1.4c9.1,0,16.4,7.4,16.4,16.4v10.7c0,9.1-7.4,16.4-16.4,16.4h-8.9c-1,0-1.8,0.8-1.8,1.8 s0.8,1.8,1.8,1.8h8.9c11.1,0,20.1-9,20.1-20.1V49.5C124.5,38.4,115.5,29.4,104.4,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.9,76.6H20.1c-9.1,0-16.4-7.4-16.4-16.4v-4.5c0-9.1,7.4-16.4,16.4-16.4c2.3,0,4.6,0.5,6.7,1.4 c1.1,0.5,2.3,0.4,3.4-0.2c1-0.6,1.6-1.7,1.6-2.9v-4.8c0-1.8,0.3-3.5,0.8-5.1c0.3-1-0.2-2-1.2-2.3c-1-0.3-2,0.2-2.3,1.2 c-0.7,2-1,4.1-1,6.3v4.6c-2.5-1.1-5.2-1.7-8-1.7C9,35.6,0,44.6,0,55.7v4.5c0,11.1,9,20.1,20.1,20.1h66.8c1,0,1.8-0.8,1.8-1.8 S87.9,76.6,86.9,76.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.2,41.9c4.4,0,3.6,3.8,6.3,3.8c1.4,0,2.2-0.8,2.2-2.2c0-2-3-5.5-8.5-5.5c-6.8,0-10.3,5.1-10.3,11 c0,7.2,3.9,11,10.5,11c4.7,0,8.3-3,8.3-6.1c0-1.2-1.2-1.8-2.3-1.8c-2.3,0-2.2,4-6,4c-4.2,0-5.7-3.3-5.7-7.2 C42.7,44.5,45.2,41.9,48.2,41.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.1,48.8c0-6.2-3.7-10.8-10.6-10.8s-10.6,4.6-10.6,10.8c0,6.4,3.1,11.3,10.6,11.3 C76.6,60.1,80.1,54.7,80.1,48.8z M63.6,48.8c0-4,1.9-6.9,5.8-6.9s5.8,2.9,5.8,6.9c0,4-1.5,7.4-5.8,7.4 C64.9,56.2,63.6,52.8,63.6,48.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.7,64.1h-4.4v0l3.4-2.1c1.7-1,2.4-2.2,2.4-3.7c0-2.1-1.4-4.2-5.3-4.2c-3.3,0-5.1,1.9-5.1,3.7 c0,1.1,0.5,1.8,1.8,1.8c2.1,0,1-2.6,3.1-2.6c1,0,1.6,0.6,1.6,1.5c0,0.8-0.3,1.3-1.2,1.9l-1.8,1.2c-3.4,2.4-3.7,3-3.7,4.1 c0,0.8,0.6,1.5,1.6,1.5h7.6c1.1,0,1.6-0.6,1.6-1.6C92.3,64.7,91.8,64.1,90.7,64.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.1,12c3.3,0,6-2.7,6-6s-2.7-6-6-6s-6,2.7-6,6C97.1,9.3,99.8,12,103.1,12z M103.1,3.7 c1.3,0,2.3,1.1,2.3,2.3s-1,2.3-2.3,2.3c-1.3,0-2.3-1.1-2.3-2.3S101.8,3.7,103.1,3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.3,91.1c-2.5,0-4.6,2.1-4.6,4.6s2.1,4.6,4.6,4.6s4.6-2.1,4.6-4.6C29.9,93.1,27.9,91.1,25.3,91.1z  M25.3,96.6c-0.5,0-1-0.4-1-1s0.4-0.9,1-0.9c0.5,0,1,0.4,1,0.9S25.8,96.6,25.3,96.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.1,82.1c-3.9,0-7.1,3.2-7.1,7.1s3.2,7.1,7.1,7.1c3.9,0,7.1-3.2,7.1-7.1C49.2,85.3,46,82.1,42.1,82.1z  M42.1,92.7c-1.9,0-3.5-1.6-3.5-3.5s1.5-3.5,3.5-3.5s3.5,1.6,3.5,3.5S44,92.7,42.1,92.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo2);
export default __webpack_public_path__ + "static/media/CO2.427c3f61818bf07d184c77da8897edac.svg";
export { ForwardRef as ReactComponent };